import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, KeyValues5, LocalService, PageKey, Status, TriggeredEvent } from '../../../service/local.service';
import { GlobalConfigEditComponent } from '../../popups/global-config-edit/global-config-edit.component';

@Component({
  selector: 'app-global-config',
  templateUrl: './global-config.component.html',
  styleUrls: ['./global-config.component.scss']
})
export class GlobalConfigComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["table"]; wrappers: KeyValues5[];
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.GlobalConfig);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onLoad();
    });
  }

  onLoad() {
    this.configurationManagementService.getGlobalConfigurations().subscribe(result => {
      this.wrappers = result;      
    });
  }

  openCreateEditPopup(id: string) {
    const modalRef = this.modalService.open(GlobalConfigEditComponent, { ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.id = id;
    modalRef.result.then((result) => {
      //if (result.event == TriggeredEvent.Ok) {
      //  if (id == '') {
      //    let wrapper = {
      //      content: {
      //        type: this.configType,
      //        updatedOn: new Date(),
      //        isActive: true
      //      },
      //      seleletedLanguageValue: result.wrapper.seleletedLanguageValue,
      //      id: result.wrapper.id
      //    };
      //    this.wrappers.push(wrapper);
      //  }
      //  else {
      //    const temp = this.wrappers.find(x => x.id == result.wrapper.id).content;
      //    temp.seleletedLanguageValue = result.wrapper.seleletedLanguageValue;
      //    temp.updatedOn = new Date();
      //  }
      //}
    });
  }

  onActiveInactiveStatus(strId: string) {
    this.configurationManagementService.activeInactiveStatus(strId, ActiveInactiveFor.GlobalConfig).subscribe(result => {
      if (result == Status.Success) {
        const updatedItem = this.wrappers.find(x => x.key == strId);
        updatedItem.v5 = updatedItem.v5 == "1" ? "0" : "1";
      }      
    });
  }
}
